"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InferenceService = void 0;
var OpenAPI_1 = require("../core/OpenAPI");
var request_1 = require("../core/request");
var InferenceService = /** @class */ (function () {
    function InferenceService() {
    }
    /**
     * Extract Keywords For Role
     * Given a role id, extract keywords for a role (admin only)
     * using chatGPT (see chatGPT configs in retool)
     * @param rid The role id
     * @param allKeywords If true, return all keywords. If false, remove keywords matching roles, categories, and skills.
     * @returns Keywords Successful Response
     * @throws ApiError
     */
    InferenceService.extractKeywordsForRole = function (rid, allKeywords) {
        if (allKeywords === void 0) { allKeywords = false; }
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/infer/keywords-admin/role/{rid}',
            path: {
                'rid': rid,
            },
            query: {
                'all_keywords': allKeywords,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Extract Keywords With User Auth
     * Given a piece of text, extract keywords (admin only)
     * using chatGPT (see chatGPT configs in retool)
     * @param requestBody
     * @returns Keywords Successful Response
     * @throws ApiError
     */
    InferenceService.extractKeywordsWithUserAuth = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/infer/keywords-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Extract Keywords For Role With Api Key
     * Given a role id, extract keywords for a role (admin only)
     * using chatGPT (see chatGPT configs in retool)
     * @param rid The role id
     * @param allKeywords If true, return all keywords. If false, remove keywords matching roles, categories, and skills.
     * @returns Keywords Successful Response
     * @throws ApiError
     */
    InferenceService.extractKeywordsForRoleWithApiKey = function (rid, allKeywords) {
        if (allKeywords === void 0) { allKeywords = false; }
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/infer/keywords/role/{rid}',
            path: {
                'rid': rid,
            },
            query: {
                'all_keywords': allKeywords,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Extract Keywords
     * Given a piece of text, extract keywords (API authentication)
     * using chatGPT (see chatGPT configs in retool)
     * @param requestBody
     * @returns Keywords Successful Response
     * @throws ApiError
     */
    InferenceService.extractKeywords = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/infer/keywords',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Extract Labels
     * Given text, return extracted skills [0:topn],
     * specializations (roles) [0:topn] and/or industries [0:topn].
     * If topn is not defined it returns all found.
     * @param requestBody
     * @returns LabelResponse Success
     * @throws ApiError
     */
    InferenceService.extractLabels = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/infer/labels',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: "Validation Error",
            },
        });
    };
    return InferenceService;
}());
exports.InferenceService = InferenceService;
//# sourceMappingURL=InferenceService.js.map